import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import { useContext, useEffect, useState } from "react";
import {
  AddClientForm,
  AlertComponent,
  ModalComponent,
  NavBar,
} from "../../components";
import DataContext from "../../context/DataContext";
import PaginatorContext from "../../context/PaginatorContext";
import { useFetch } from "../../hooks";
import { ClientProps, ProductProps } from "../../interfaces/interfaces";
import styles from "../main.module.sass";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { IconButton, Tooltip, useMediaQuery, useTheme } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useNavigate } from "react-router-dom";
import {
  modernDataGridStyles,
  modernIconButtonStyles,
} from "../../utils/dataGridStyles";

interface FetchResponse {
  success?: boolean;
  data: ProductProps[];
}

export const ClientPage = () => {
  const theme = useTheme();
  const { paginationModel, fetchPaginationModel } =
    useContext(PaginatorContext);
  const matches = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const { data, error, isLoading, fetchData, pagination } =
    useFetch<FetchResponse>("client-paginate", paginationModel);
  const [isModalOpen, setIsModalOpen] = useState<Boolean>(false);
  const [clientToEdit, setClientToEdit] = useState<ClientProps>({
    id: 0,
    name: "",
  });
  const [isCreateClient, setIsCreateClient] = useState(false);
  const { isSuccess, isError, onCreateClient, onEditClient } =
    useContext(DataContext);

  const [tableData, setTableData] = useState<ProductProps[]>([]);

  useEffect(() => {
    data && data.data && setTableData(data.data);
  }, [data]);

  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: "Client",
      renderHeader: () => <strong>{"CLIENT"}</strong>,
      sortable: true,
      width: 220,
    },
    {
      field: "edit",
      headerName: "Actions",
      renderHeader: () => <strong>{"ACTIONS"}</strong>,
      width: 150,
      renderCell: (params: any) => {
        return (
          <div className="action-buttons">
            <Tooltip title="Detail">
              <IconButton
                onClick={() => {
                  navigate(`/client/${params.row.id}`);
                }}
                sx={modernIconButtonStyles(theme)}
                size="small"
              >
                <OpenInNewIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
              <IconButton
                onClick={() => {
                  setIsCreateClient(false);
                  setClientToEdit(params.row);
                  setIsModalOpen(true);
                }}
                sx={modernIconButtonStyles(theme)}
                size="small"
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  let content: JSX.Element | JSX.Element[];

  const buttons = [
    {
      title: "New",
      action: () => {
        setIsCreateClient(true);
        setIsModalOpen(true);
      },
      icon: <AddBoxIcon />,
    },
  ];
  return (
    <>
      <NavBar title="Clients" buttons={buttons} />
      <div className={styles.center}>
        <div style={{ height: "80vh" }} className={styles.techProposalForm}>
          <DataGrid
            slots={{ toolbar: GridToolbar }}
            density={matches ? "standard" : "compact"}
            sx={modernDataGridStyles(theme)}
            rows={tableData}
            columns={columns}
            loading={isLoading}
            rowCount={+pagination?.totalRecords}
            paginationMode="server"
            paginationModel={paginationModel}
            onPaginationModelChange={fetchPaginationModel}
          />
        </div>
        {isModalOpen && (
          <ModalComponent
            modalContent={
              <AddClientForm
                value={!isCreateClient ? clientToEdit.name : null}
                onCancel={() => setIsModalOpen(false)}
                onEditClient={
                  !isCreateClient
                    ? (values) => {
                        onEditClient(clientToEdit.id, values, undefined, () => {
                          fetchData();
                          setIsModalOpen(false);
                        });
                      }
                    : undefined
                }
                onAddClient={
                  isCreateClient
                    ? (name) => {
                        onCreateClient(name, () => {
                          fetchData();
                          setIsModalOpen(false);
                          setIsCreateClient(false);
                        });
                      }
                    : undefined
                }
              />
            }
          />
        )}
        {isSuccess && <AlertComponent type="success" />}
        {isError && <AlertComponent type="error" />}
      </div>
    </>
  );
};
